import { blockKey, useAnswerSession } from "../session"
import { useBlockScope } from "./context"

/** Relying on an authority, or answering it: the user's side decides which reading comes first. */
export function YourUse({ for: pro, against, path }: { for: string[]; against: string[]; path: string }) {
  const { turn, section } = useBlockScope()
  const k = blockKey(turn, section, path)
  const side = useAnswerSession((s) => s.choices[k] ?? "")
  const choose = useAnswerSession((s) => s.choose)
  const opts: [string, string][] = [["for", "I'm relying on it"], ["against", "It's used against me"]]
  return (
    <>
      <div className="ask">
        <p className="q">Are you relying on it, or is it being used against you?</p>
        <div className="pills" role="group" aria-label="Your side">
          {opts.map(([v, l]) => (
            <button key={v} type="button" className="pill" aria-pressed={side === v} onClick={() => choose(k, v)}>
              {l}
            </button>
          ))}
        </div>
      </div>
      <div className="usec" data-first={side}>
        {pro.length ? (
          <div className="u-for">
            <p className="lab">If you rely on it</p>
            <ul className="blist">{pro.map((x, i) => <li key={i}>{x}</li>)}</ul>
          </div>
        ) : null}
        {against.length ? (
          <div className="u-against">
            <p className="lab">If it is used against you</p>
            <ul className="blist">{against.map((x, i) => <li key={i}>{x}</li>)}</ul>
          </div>
        ) : null}
      </div>
    </>
  )
}
